export const getPublicIP = async (): Promise<string | null> => {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return data.ip;
  } catch (err) {
    console.error('Failed to fetch IP address:', err);
    return null;
  }
};

export const getUserIP = async (): Promise<string | null> => {
  const userIP = await getPublicIP();
  // const allowedIPs = ['54.227.44.17','139.84.144.218','107.22.40.80','3.6.118.61','180.151.48.130','106.51.0.250'];
  const allowedIPs = process.env.REACT_APP_Chennai_IP_Address
    ? process.env.REACT_APP_Chennai_IP_Address.split(',')
    : [];
  const location = userIP && allowedIPs.includes(userIP) ? 'CHN Office' : 'Others';
  // console.log(allowedIPs,"allowedIps", userIP," userIP", location, "location", allowedIPs.includes(userIP),"testing");

  return location;
}

export const getDeviceType = () => {
  const ua = navigator.userAgent;

  if (/mobile/i.test(ua)) {
    return "Mobile";
  }

  if (/tablet/i.test(ua)) {
    return "Tablet";
  }

  if (/iPad|Android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(ua)) {
    return "Tablet";
  }

  if (/Macintosh|Windows NT|Linux x86_64|X11/i.test(ua)) {
    return "Desktop";
  }

  return "Unknown";
};

import { format, isValid, parseISO } from 'date-fns';

export const cleanObject = (obj: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => {
      if (v == null) return false; // skip null/undefined
      if (Array.isArray(v)) return v.length > 0; // skip empty arrays
      if (typeof v === "string") return v.trim() !== ""; // skip empty strings
      return true; // keep numbers, objects, etc.
    })
  );

// ============================================================================
// Date Formatting Utilities
// ============================================================================

type DateInput = Date | string | null | undefined;

/**
 * Format date for HTML date inputs.
 * Always returns YYYY-MM-DD format (required by <input type="date">).
 * 
 * Handles:
 * - Date objects
 * - ISO strings (2025-01-06T00:00:00.000Z)
 * - Already formatted strings (2025-01-06) - passthrough
 * - null/undefined - returns empty string
 * 
 * @example
 * formatDateForInput(new Date()) // "2025-01-06"
 * formatDateForInput("2025-01-06T10:30:00Z") // "2025-01-06"
 * formatDateForInput("2025-01-06") // "2025-01-06" (passthrough)
 */
export const formatDateForInput = (dateValue: DateInput): string => {
  if (!dateValue) return '';

  // Passthrough: already in YYYY-MM-DD format
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }

  // Parse and format
  let date: Date;
  if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    // Try ISO parse first
    date = parseISO(dateValue);
    if (!isValid(date)) {
      // Fallback to Date constructor
      date = new Date(dateValue);
    }
  }

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
};

/**
 * Format date for display purposes.
 * Uses the provided format string (from org config) or defaults to 'dd-MM-yyyy'.
 * 
 * @param dateValue - Date to format
 * @param displayFormat - date-fns format string (e.g., 'dd-MM-yyyy', 'dd/MM/yyyy')
 * 
 * @example
 * const { dateFormat } = useOrgConfig();
 * formatDateForDisplay(record.createdAt, dateFormat) // "06-01-2025"
 */
export const formatDateForDisplay = (
  dateValue: DateInput,
  displayFormat: string = 'dd-MM-yyyy'
): string => {
  if (!dateValue) return '';

  // Parse the date
  let date: Date;
  if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    date = parseISO(dateValue);
    if (!isValid(date)) {
      date = new Date(dateValue);
    }
  }

  if (!isValid(date)) {
    return '';
  }

  return format(date, displayFormat);
};